import script from "./RegistrationCultureTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationCultureTable.vue?vue&type=script&setup=true&lang=ts"

import "./RegistrationCultureTable.vue?vue&type=style&index=0&id=ee64547a&lang=scss"

const __exports__ = script;

export default __exports__